export default {
  EDIT_ANNOTATION: 'EditAnnotationControl',
  DELETE_ANNOTATION: 'DeleteAnnotationControl',
  TRANSLATE: 'TranslateControl',
  LOOKUP: 'LookupControl',
  PLAY_AUDIO: 'PlayAudioControl',
  CREATE_ANNOTATION: 'CreateAnnotationControl',
  SEARCH: 'SearchControl',
  EXTRACT: 'ExtractControl',
  COPY_TEXT: 'CopyTextControl',
  SOCIAL_SHARING: 'SocialSharingControl',
  TYPO: 'TypoControl',
  BOOKMARK: 'BookmarkControl',
  ILM: 'ILMControl',
  HIGHLIGHT: 'HighlightControl',
  BLOG_QUOTE: 'BlogQuoteControl'
};
